<template>
    <v-container fluid>
        <v-row class="mt-6 ml-6">
            <h1>編輯問卷</h1>
        </v-row>
        <v-row class="mt-6 ml-6">
            <h3 class="mt-2">問卷題目</h3>
        </v-row>
        <div v-for="(q, idx) in question_list" :key="idx">
            <choice v-if="q.type==1 && q.status!=2" @update="question_update" :index="q.idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></choice>
            <essay v-if="q.type==2 && q.status!=2" @update="question_update" :index="q.idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></essay>
            <matrix v-if="q.type==3 && q.status!=2" @update="question_update" :index="q.idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></matrix>
            <multiplechoice v-if="q.type==4 && q.status!=2" @update="question_update" :index="q.idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></multiplechoice>
            <choicewithtext v-if="q.type==5 && q.status!=2" @update="question_update" :index="q.idx+1" :tid="q.id" :question="q.question" @deleted="deleted"></choicewithtext>
        </div>

        <v-row class="mt-6 ml-1">
            <v-btn @click="question_type=-1; add_question_dialog=true" color="primary">新增題目</v-btn>
        </v-row>

        <v-row class="mt-6 mr-1">
            <v-spacer></v-spacer>
            <v-btn @click="save" class="ml-3 mt-3" color="success">儲存</v-btn>
        </v-row>

        <v-dialog v-model="add_question_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">題型設定
                    <v-spacer/>
                    <v-icon @click="add_question_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-select v-model="question_type" :items="[{label: '單選題', value: 1}, {label:'簡答題', value: 2}, {label:'矩陣題', value: 3}, {label:'多選題', value: 4}, {label:'單選題加註文字', value: 5}]" item-text='label' item-value='value' label="請選擇題型" class="input_200" outlined></v-select>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="add_question_submit" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import ContentIconCard from '../materials/ContentIconCard'
import Choice from '../materials/question/Choice'
import Essay from '../materials/question/Essay'
import Matrix from '../materials/question/Matrix'
import Multiplechoice from '../materials/question/Multiplechoice'
import Choicewithtext from '../materials/question/Choicewithtext'
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL

export default {
    components:{ContentIconCard, Choice, Essay, Matrix, Multiplechoice, Choicewithtext},
    data(){
        return {
            survey_id: -1,
            survey_title: "",

            add_question_dialog: false,
            question_type: 1,
            question_list: [],
        }
    },
    created(){
        let check = 's' in this.$route.query
        if(check == false) {
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/question_overview')
        }
        this.survey_id = this.$route.query.s
        this.get_question_list()
    },
    methods: {
        set_idx(){
            let idx = 0
            for(let i in this.question_list){
                if(this.question_list[i].status!=2){
                    this.question_list[i]['idx'] = idx
                    idx += 1
                }
            }
        },
        get_question_list(){
            let post_data = {survey_id: this.survey_id}

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)
                    this.question_list = tmp.question_list
                    // 新增一個flag 判斷 0:尚未改變 1:編輯 2:刪除
                    for(let q of this.question_list)
                        q['status'] = 0

                    //　更新ｉｄｘ
                    this.set_idx()
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        question_update(val){
            console.log('update', this.question_list)
            let idx = this.question_list.findIndex(e=>e.id==val[0])
            this.question_list[idx]['question'] = val[1]
            this.question_list[idx]['status'] = 1
        },
        deleted(val){
            console.log(val)
            let tmp = JSON.parse(JSON.stringify(this.question_list))
            let idx = tmp.findIndex(e=>e.id==val)
            if(val < 0){
                tmp.splice(idx, 1)
            }
            else{
                tmp[idx].status = 2
            }
            this.question_list = tmp

            //　更新ｉｄｘ
            this.set_idx()
        },
        check_data(post_data){
            console.log('~~~~~~~In check_data')
            let msg = ""
            if(post_data['survey_title'] == "")
                msg += "問卷名稱尚未填寫!\n"
            if(post_data['vendor'] == "")
                msg += "所屬廠商尚未填寫!\n"
            let q_list = post_data['question_list']

            if(q_list.length == 0)
                msg += "尚未新增問題!\n"

            for(let idx in q_list){
                console.log('1111111111111111')
                console.log(q_list[idx])
                console.log()
                if(q_list[idx].status == 2)
                    continue

                console.log('222222222222222222')

                let num = Number(idx)+1
                let tmp = q_list[idx]
                if(tmp['type'] == 1){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let option = tmp['question']['choice'][idx2]
                            if(option['title'] == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            if(String(option['score']) == "")
                                msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
                if(tmp['type'] == 2){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題描述尚未填寫!\n"
                }
                if(tmp['type'] == 3){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題描述尚未填寫!\n"

                    if(tmp['question']['title_list'].length == 0){
                        msg += "問題"+num+": 尚未新增子問題!\n"
                    }
                    else{

                        let tlist = tmp['question']['title_list']
                        for(let t of tlist)
                            if(t.title == '')
                                msg += "問題"+num+": 子問題不可空白!\n"
                    }
                }
                if(tmp['type'] == 4){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let option = tmp['question']['choice'][idx2]
                            if(option['title'] == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            // if(String(option['score']) == "")
                            //     msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
                if(tmp['type'] == 5){
                    if(tmp['question']['title'] == '')
                        msg += "問題"+num+": 問題尚未填寫!\n"
                    if(tmp['question']['choice'].length == 0){
                        msg += "問題"+num+": 尚未新增選項!\n"
                    }
                    else{
                        for(let idx2 in tmp['question']['choice']){
                            let num2 = Number(idx2)+1
                            let option = tmp['question']['choice'][idx2]
                            if(option['title'] == "")
                                msg += "問題"+num+": 第"+num2+"選項內容尚未填寫!\n"
                            // if(String(option['score']) == "")
                            //     msg += "問題"+num+": 第"+num2+"選項分數尚未填寫!\n"
                        }
                    }
                }
            }
            return msg
        },
        save(){
            let post_data = {
                survey_id: this.survey_id,
                question_list: this.question_list,
            }
            let msg = this.check_data(post_data)
            if(msg != ""){
                bus.$emit('alert', {msg: msg, title: "提示",　check: "我知道了"})
                return
            }
            axios.post(host_url+'edit_question/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.$router.push('/question_content?m=0&s='+this.survey_id)
                }
                else{
                    bus.$emit('alert', {msg: '新增失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        pos_change(name, item, type_){
            let item_list
            if(name=='header'){
                item_list = this.headers
            }
            else{
                item_list = this.table_data
            }
            let idx = item_list.findIndex(e=>e.text==item.text)
            if(type_ == "up" && idx>1){
                let tmp = item_list[idx-1]
                this.$set(item_list, idx-1, item_list[idx])
                this.$set(item_list, idx, tmp)
            }
            if(type_ == "down" && idx!=item_list.length-1){
                let tmp = item_list[idx+1]
                this.$set(item_list, idx+1, item_list[idx])
                this.$set(item_list, idx, tmp)
            }
        },
        add_question_submit(){
            let tmp = {}
            if(this.question_type == 1){
                tmp['title'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }

            if(this.question_type == 2){
                tmp['title'] = ""
                tmp['description'] = ""
            }

            if(this.question_type == 3){
                tmp['title'] = ''
                tmp['headers_list'] = []
                tmp['title_list'] = []
                tmp['description_list'] = []
            }
            if(this.question_type == 4){
                tmp['title'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }
            if(this.question_type == 5){
                tmp['title'] = ""
                tmp['description'] = ""
                tmp['choice'] = []
                tmp['trigger_msg'] = ""
            }
            this.question_list.push({type: this.question_type, question: tmp, id: (this.question_list.length+1)*-1})
            this.add_question_dialog = false

            //　更新ｉｄｘ
            this.set_idx()
        },
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_400{
    max-width: 400px;
}

::v-deep .input_100{
    max-width: 100px;
}

::v-deep .input_700{
    max-width: 700px;
}


</style>
